import { useMutation, useQueryClient, type QueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  cambiarEstadoPermiso,
  crearPermiso,
  editarPermiso,
  eliminarPermiso,
  type CrearPermisoInput,
  type EditarPermisoInput,
} from "../services/permisos-service";

function invalidar(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: qk.adminPermisos }); // cubre gestión + el catálogo del editor de roles
}

export function useCrearPermiso(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearPermisoInput) => crearPermiso(input),
    onSuccess: (p) => {
      toastExito({
        title: `Permiso '${p.codigo}' creado`,
        message: "Queda «pendiente de cablear»: no otorga acceso hasta que un desarrollador lo conecte en el código.",
      });
      invalidar(qc);
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEditarPermiso(opts?: { onEditado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EditarPermisoInput }) => editarPermiso(id, input),
    onSuccess: () => {
      toastExito({ title: "Permiso actualizado" });
      invalidar(qc);
      opts?.onEditado?.();
    },
    onError: toastErrorApi,
  });
}

export function useCambiarEstadoPermiso() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, activo }: { id: string; activo: boolean }) => cambiarEstadoPermiso(id, activo),
    onSuccess: (p) => {
      toastExito({ title: p.activo ? `Permiso '${p.codigo}' activado` : `Permiso '${p.codigo}' desactivado` });
      invalidar(qc);
    },
    onError: toastErrorApi,
  });
}

export function useEliminarPermiso() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarPermiso(id),
    onSuccess: () => {
      toastExito({ title: "Permiso eliminado" });
      invalidar(qc);
    },
    onError: toastErrorApi,
  });
}
